// extracted by mini-css-extract-plugin
module.exports = {"container":"spinner_container__1n3DI","noMaxHeight":"spinner_noMaxHeight__1FYfg","ldsFacebook":"spinner_ldsFacebook__nIBHT","miniSpinner":"spinner_miniSpinner__2tbqd"};